import type { EstimateType } from "@/enums/estimate-type";

export interface XactimateExportInitiatedProps {
  estimate_id: string;
  estimate_type?: EstimateType;
  previously_exported: boolean;
}

export interface PdfExportInitiatedProps {
  estimate_id: string;
  export_type: "summarized" | "itemized" | "photo_report";
}

export const EXPORT_EVENTS = {
  XACTIMATE_EXPORT_INITIATED: "xactimate_export_initiated",
  PDF_EXPORT_INITIATED: "pdf_export_initiated",
} as const;

export interface ExportEventPropertiesMap {
  [EXPORT_EVENTS.XACTIMATE_EXPORT_INITIATED]: XactimateExportInitiatedProps;
  [EXPORT_EVENTS.PDF_EXPORT_INITIATED]: PdfExportInitiatedProps;
}
